<template>
  <v-container>
    <!--app-view-toolbar-->
    <app-view-toolbar :title="headline" :showBackButton="true" :isEdit="false"></app-view-toolbar>
    <v-form ref="formSignup">
      <v-row>
        <v-col cols="12" :sm="!isLoggedIn ? 6 : 12">
          <div class="text-h5 mb-4" v-if="!isLoggedIn">Åkeriets uppgifter</div>
          <!--company-form-fields-->
          <app-company-form-fields :data="viewData.companyData" mode="signup"></app-company-form-fields>
        </v-col>
        <v-col cols="12" sm="6" v-if="!isLoggedIn">
          <div class="text-h5 mb-4">Dina uppgifter</div>
          <!--user-form-fields-->
          <app-user-form-fields :data="viewData.userData"></app-user-form-fields>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox
            v-model="payMinimumSalary"
            :rules="[formRules.checked(payMinimumSalary, 'Du måste bekräfta')]"
          >
            <template v-slot:label>
              Åkeriet betalar lön minst enligt gällande kollektivavtal
            </template>
          </v-checkbox>
          <v-checkbox
            v-model="iAmAuthorized"
            :rules="[formRules.checked(iAmAuthorized, 'Du måste bekräfta')]"
          >
            <template v-slot:label>
              Jag är behörig företrädare för bolaget till att skapa/använda chaffis.se
            </template>
          </v-checkbox>
          <!--approve-gdpr-policy-->
          <app-approve-gdpr-policy :data="approveGdprPolicyData"></app-approve-gdpr-policy>
        </v-col>
      </v-row>
    </v-form>
    <!--app-form-bottom-->
    <app-form-bottom
      :postWasInvalid="postWasInvalid"
      :errorOutput="errorOutput"
      @onSubmit="doSubmit"
      @onErrorOk="postWasInvalid = false"
      submitText="Registrera"
    ></app-form-bottom>
    <!--bank-id-->
    <app-bank-id
      headline="Verifiera med BankID"
      mode="auth"
      :dialog="showBankIdDialog"
      @close="showBankIdDialog = false"
      @complete="onBankIdComplete"
      :returnUrl="bankIdReturnUrl"
    ></app-bank-id>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>
<script>
import axios from 'axios'
import BankId from '../components/BankId'
import SnackBar from '../components/SnackBar'
import UserFormFields from '../components/UserFormFields'
import FormBottom from '../components/FormBottom'
import ViewToolbar from '../components/ViewToolbar'
import CompanyFormFields from '../components/CompanyFormFields'
import ApproveGdprPolicy from '../components/ApproveGdprPolicy'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { snackBarBus } from '../main'
import { mapGetters } from 'vuex'

export default {
  name: 'SignupCompany',
  components: {
    'app-bank-id': BankId,
    'app-snack-bar': SnackBar,
    'app-form-bottom': FormBottom,
    'app-view-toolbar': ViewToolbar,
    'app-user-form-fields': UserFormFields,
    'app-company-form-fields': CompanyFormFields,
    'app-approve-gdpr-policy': ApproveGdprPolicy
  },
  mixins: [generalMixin, urlMixin], 
  data() {
    return {
      bankIdReturnUrl: '',
      payMinimumSalary: false,
      iAmAuthorized: false,
      approveGdprPolicyData: {
        approveGdpr: false,
      },
      viewData: {
        userData: {
          firstname: '',
          lastname: '',
          email: '',
          mobile: ''
        },
        companyData: {
          name: '',
          organizationNumber: '',
          address: '',
          address2: '',
          zip: '',
          city: '',
          phone: '',
          email: ''
        }
      },
      postWasInvalid: false,
      errorOutput: '',
      showBankIdDialog: false,
      bankIdToken: null,
      headline: ''
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'access_token']),
  },
  methods: {
    doSubmit(doCommitSave = false) {
      if (this.isLoggedIn) {
        doCommitSave = true
      }
      const allowSubmitOfInvalidForm = false
      let okToSubmit = true;
      if (!allowSubmitOfInvalidForm) {
        const formIsValid = this.$refs.formSignup.validate()
//        console.log('formIsValid', formIsValid)
        okToSubmit = formIsValid
      }
      if (okToSubmit) {
        //post data to API
        let postData = {
          doCommitSave: doCommitSave,
          companyData: this.viewData.companyData,
          payMinimumSalary: this.payMinimumSalary,
          iAmAuthorized: this.iAmAuthorized,
          approveGdpr: this.approveGdprPolicyData.approveGdpr
        }
        let config
        if (this.isLoggedIn) {
          //when logged in, authorize via access_token
          config = {
            headers: {
              'Authorization': this.access_token
            }
          }
        } else {
          //when not logged in, authorize via bankIdToken if doCommitSave
          config = {
            headers: {
              'Authorization': (doCommitSave) ? this.bankIdToken : ''
            }
          }
          //also append userData to postData
          postData.userData = this.viewData.userData
        }
        let url = this.url_composeApiUrl('/company/signup')
        axios.post(url, postData, config)
          .then(response => {
//            console.log('post response', response)
            if (response.data.success) {
              //success
              if (doCommitSave) {
                //call action onAuth in store
                let dataToDispatch = {
                  loggedInData: response.data.returnData.loggedInData
                }
                if (!this.isLoggedIn) {
                  //also append access_token
                  dataToDispatch.access_token = response.data.returnData.access_token
                }
                this.$store.dispatch('onAuth', dataToDispatch).then(() => {
                  //go to dashboard
                  this.$router.replace({ name: 'company-dashboard'})
                })
              } else {
                //this was just a 'pre-bankId test save' - show bankID
                this.showBankIdDialog = true;
              }
            } else {
              //non success
              this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
              this.postWasInvalid = true
            }
          })
          .catch(error => {
            snackBarBus.$emit('message', error.toString())
            this.postWasInvalid = true
          })
      }
    },
    onBankIdComplete(token) {
//      console.log("CompanySignup - onBankIdComplete", token)
      this.showBankIdDialog = false
      this.bankIdToken = token
      //submit and commit
      this.doSubmit(true)
    }
  },
  created() {
    this.bankIdReturnUrl = this.getAbsUrl('/home')
    this.headline = this.isLoggedIn ? 'Registrera nytt åkeri' : 'Registrera åkerikonto'
  }
}
</script>
